module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio-5779bc2e6a18815c989eb30acd1e4d9a.webp";